module.exports = __webpack_public_path__ + "static/media/accept-btn.81aade83.svg";